import React, { useEffect, useState } from 'react';
import api from '../services/api';
import '../styles/ProjectAcquisition.css';
import AcquisitionModal from '../modals/AcquisitionModal';

export default function ProjectAcquisition() {
    const [acquisitions, setAcquisitions] = useState([]);
    const [filteredAcquisitions, setFilteredAcquisitions] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editAcquisition, setEditAcquisition] = useState(null);
    const [statusFilter, setStatusFilter] = useState('');
    const [companyFilter, setCompanyFilter] = useState('');

    useEffect(() => {
        loadAcquisitions();
    }, []);

    const loadAcquisitions = () => {
        api.get('/projectacquisition')
            .then(res => {
                setAcquisitions(res.data);
                setFilteredAcquisitions(res.data);
            })
            .catch(err => console.error('Failed to load acquisitions', err));
    };

    const handleAdd = () => {
        setEditAcquisition(null);
        setShowModal(true);
    };

    const handleEdit = (acquisition) => {
        setEditAcquisition(acquisition);
        setShowModal(true);
    };

    const handleDelete = (id) => {
        if (window.confirm('Are you sure you want to delete this project acquisition?')) {
            api.delete(`/projectacquisition/${id}`)
                .then(() => loadAcquisitions())
                .catch(err => alert('Failed to delete'));
        }
    };

    const handleModalSave = () => {
        setShowModal(false);
        loadAcquisitions();
    };

    // Filterfunktion
    useEffect(() => {
        let filtered = acquisitions;

        if (statusFilter) {
            filtered = filtered.filter(a => a.status === statusFilter);
        }

        if (companyFilter) {
            filtered = filtered.filter(a =>
                a.companyName.toLowerCase().includes(companyFilter.toLowerCase())
            );
        }

        setFilteredAcquisitions(filtered);
    }, [statusFilter, companyFilter, acquisitions]);

    return (
        <div className="acquisition-container">
            <h2>Projektakquise</h2>

            <div className="filter-container">
                <input
                    type="text"
                    placeholder="Anfrage suchen..."
                    value={companyFilter}
                    onChange={e => setCompanyFilter(e.target.value)}
                    className="input_filter"
                />

                <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="input">
                    <option value="">Alle</option>
                    <option value="New">Neu</option>
                    <option value="InProgress">In Bearbeitung</option>
                    <option value="OfferCreated">Angebot erstellt</option>
                    <option value="Won">Gewonnen</option>
                    <option value="Lost">Verloren</option>
                </select>

                <button className="button" onClick={handleAdd}>Anfrage hinzufügen</button>
            </div>

            <table className="table">
                <thead>
                <tr>
                    <th>Firma</th>
                    <th>Projekt</th>
                    <th>Budget</th>
                    <th>Status</th>
                    <th>Ansprechpartner</th>
                    <th>Letztes Update</th>
                    <th>Aktionen</th>
                </tr>
                </thead>
                <tbody>
                {filteredAcquisitions.map(acq => (
                    <tr key={acq.id}>
                        <td>{acq.companyName}</td>
                        <td>{acq.projectTitle}</td>
                        <td>{acq.expectedBudget?.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</td>
                        <td>{acq.status}</td>
                        <td>{acq.contactPerson} ({acq.contactEmail})</td>
                        <td>{new Date(acq.updatedAt).toLocaleDateString()}</td>
                        <td>
                            <button className="button-warning" onClick={() => handleEdit(acq)}>Bearbeiten</button>
                            <button className="button-danger" onClick={() => handleDelete(acq.id)}>Löschen</button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>

            {showModal && (
                <AcquisitionModal
                    acquisition={editAcquisition}
                    onClose={() => setShowModal(false)}
                    onSave={handleModalSave}
                />
            )}
        </div>
    );
}
